import { E164_PHONE_PATTERN } from '@erp/shared-types';

export interface FailureSmsSenderChoice {
  id: string;
  phoneNumber: string;
}

/**
 * Sender numbers for a failure text. A saved id that is no longer in the
 * organization's list stays visible so the row does not look empty.
 */
export function failureSmsSenderChoices(
  numbers: readonly FailureSmsSenderChoice[],
  selectedId: string,
  savedLabel: string,
): FailureSmsSenderChoice[] {
  if (
    selectedId.length === 0 ||
    numbers.some((number) => number.id === selectedId)
  ) {
    return [...numbers];
  }
  return [{ id: selectedId, phoneNumber: savedLabel }, ...numbers];
}

export function senderSelectDisabled(
  loading: boolean,
  choiceCount: number,
): boolean {
  return loading || choiceCount === 0;
}

export function showMissingSenderHint(input: {
  senderCount: number;
  loading: boolean;
  error: boolean;
}): boolean {
  return input.senderCount === 0 && !input.loading && !input.error;
}

export function failureSmsRecipientInvalid(to: string): boolean {
  return to.length > 0 && !E164_PHONE_PATTERN.test(to);
}
